import { Pipe, PipeTransform } from '@angular/core';
import { Newtype } from 'newtype-ts/es6';
import { FormControlState, FormControlValueTypes, FormGroupState } from 'ngrx-forms';

@Pipe({ name: 'unwrapFormControl', pure: true })
export class UnwrapFormControlPipe implements PipeTransform {
  public transform<T extends FormGroupState<Newtype<any, FormControlValueTypes>>>(
    value: T,
  ): T extends FormGroupState<Newtype<any, infer A>>
    ? A extends FormControlValueTypes
      ? FormControlState<A>
      : never
    : never {
    return value as unknown as T extends FormGroupState<Newtype<any, infer A>>
      ? A extends FormControlValueTypes
        ? FormControlState<A>
        : never
      : never;
  }
}
